// extracted by mini-css-extract-plugin
export default {"testimonialSetion":"testimonial_testimonialSetion__6G-NW","title":"testimonial_title__x5Wfl","subtitle":"testimonial_subtitle__FvBSH","teste":"testimonial_teste__egIwV"};